import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal.jsx';
import { getShiftsForStore, postShiftDeletion } from '../../Api.js';
import { ReasonDropdown } from '../common/ReasonDropdown.jsx';
import useStore from '../../hooks/StoreHook.jsx';

export const DELETION_OPTIONS = {
  EXISTING_STAFF: {
    key: 'EXISTING_STAFF',
    text: 'Shift filled by existing staff',
  },
  OUTSIDE_STAFF: {
    key: 'OUTSIDE_STAFF',
    text: 'Shift filled outside of Locumly',
  },
  NOT_VACANT: {
    key: 'NOT_VACANT',
    text: 'Shift no longer vacant',
  },
  OTHER: {
    key: 'OTHER',
    text: 'Other',
  }
};

export const DeleteShiftConfirmation = ({ close, confirm, setReason, reason }) => {
  const [loading, setLoading] = useState(false);
  const onConfirm = () => confirm(setLoading);
  return (
    <ConfirmationModal additionalClassName={'delete-shift-confirmation'} close={close} confirm={onConfirm} loading={loading} confirmText={'Delete this shift'} disabled={reason === null}>
      <h3 className={'confirmation-title'}>{'Are you sure?'}</h3>
        <p className={'confirmation-text'}>
          {`You won't be able to recover this shift or see its applicants once it has been deleted.`}
        </p>
        <section className={'reason-dropdown-container'}>
          <span className={'reason-text'}>{'Reason: '}</span>
          <ReasonDropdown setReason={setReason} reason={reason} options={DELETION_OPTIONS} />
        </section>
    </ConfirmationModal>
  );
};

export const DeleteShiftButton = ({ shiftId, returnToShifts, onAfterDelete, listStoreId, buttonClassName = 'delete-shift shift-button very-dark', children = 'Delete shift' }) => {
  const { setShifts, storeId: contextStoreId } = useStore();
  const refreshStoreId = listStoreId !== undefined && listStoreId !== null ? listStoreId : contextStoreId;
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(null);
  const close = () => {
    setOpen(false);
    setReason(null);
  };
  const confirm = (setLoading) => {
    setLoading(true);
    postShiftDeletion(shiftId, reason)
      .then(() => {
        getShiftsForStore(refreshStoreId)
          .then(({ shifts }) => {
            setShifts(shifts);
            setLoading(false);
            close();
            if (typeof returnToShifts === 'function') {
              returnToShifts();
            }
            if (typeof onAfterDelete === 'function') {
              onAfterDelete();
            }
          })
          .catch((err) => console.error(err));
      })
      .catch((err) => console.error(err));
  };
  return (
    <>
      <button type={'button'} className={buttonClassName} onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
        {children}
      </button>
      {open && <DeleteShiftConfirmation close={close} confirm={confirm} setReason={setReason} reason={reason} />}
    </>
  );
};
